import { render, staticRenderFns } from "./tab-header.vue?vue&type=template&id=cd371a84&scoped=true&"
import script from "./tab-header.vue?vue&type=script&lang=js&"
export * from "./tab-header.vue?vue&type=script&lang=js&"
import style0 from "./tab-header.vue?vue&type=style&index=0&id=cd371a84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd371a84",
  null
  
)

export default component.exports